import { render, staticRenderFns } from "./MaskItem.vue?vue&type=template&id=c5a92266&scoped=true"
import script from "./MaskItem.vue?vue&type=script&lang=js"
export * from "./MaskItem.vue?vue&type=script&lang=js"
import style0 from "./MaskItem.vue?vue&type=style&index=0&id=c5a92266&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a92266",
  null
  
)

export default component.exports